import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff5d7434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signin-page page d-flex flex-column" }
const _hoisted_2 = { class: "page-content d-flex flex-grow-1 justify-content-center align-items-center" }
const _hoisted_3 = { class: "signin-wrapper d-flex flex-column" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "error pt-5"
}

import { Constants } from "@/classes/constants";
import { tenant } from "@/tenants/tenant";
import { useUserStore } from "@/store/user-store";
import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInPage',
  setup(__props) {

const data = reactive({
	errorMessage: null as string | null
});

const userStore = useUserStore();
const route = useRoute();

onMounted(()=>{
	if(route.query.error == Constants.errorLicenseExpired){
		data.errorMessage = "Your license has expired, please contact support.";
	}else if(route.query.error == Constants.errorUserLimitReached){
		data.errorMessage = `${tenant.productName} is at capacity right now, we will notify you when new spots are available.`;
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "logo",
          src: _unref(tenant).assets.signInLogoUrl,
          alt: _unref(tenant).displayName + ' logo'
        }, null, 8, _hoisted_4),
        _createElementVNode("button", {
          class: "btn btn-filled btn-signin",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(userStore).login()))
        }, "SIGN IN"),
        _createElementVNode("button", {
          class: "btn-link btn-signup",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(userStore).login(true)))
        }, "Sign up / register "),
        (data.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(data.errorMessage), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})